import { render, staticRenderFns } from "./ProfileForexCurrencyPairEditorModal.vue?vue&type=template&id=16a2f49c"
import script from "./ProfileForexCurrencyPairEditorModal.vue?vue&type=script&lang=js"
export * from "./ProfileForexCurrencyPairEditorModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileForexCurrencyPairEditorModal.vue?vue&type=style&index=0&id=16a2f49c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports